import type {
  AdminDefaultVendorResponse,
  AdminVendorsResponse,
  ClaimPublicAdjusterResponse,
  VendorClaimDetailResponse,
  VendorClaimDocumentDownloadResponse,
  VendorClaimDocumentsResponse,
  VendorClaimsResponse,
  VendorType,
} from '@/types/adminVendors/adminVendorsTypes'
import type { VendorStatusResponse } from '@/types/ui/uiTypes'

export async function fetchAdminVendors(type?: VendorType): Promise<AdminVendorsResponse> {
  const query = type ? `?type=${encodeURIComponent(type)}` : ''
  return $fetch<AdminVendorsResponse>(`/api/admin/vendors${query}`)
}

export async function fetchAdminDefaultVendor(): Promise<AdminDefaultVendorResponse> {
  return $fetch<AdminDefaultVendorResponse>('/api/admin/vendors/default')
}

export async function fetchVendorClaims(): Promise<VendorClaimsResponse> {
  return $fetch<VendorClaimsResponse>('/api/vendors/claims')
}

export async function fetchVendorClaimDocuments(claimId: string): Promise<VendorClaimDocumentsResponse> {
  return $fetch<VendorClaimDocumentsResponse>(`/api/vendors/claims/${claimId}/documents`)
}

export async function fetchVendorClaimDocumentDownloadUrl(
  claimId: string,
  documentId: string,
): Promise<VendorClaimDocumentDownloadResponse> {
  return $fetch<VendorClaimDocumentDownloadResponse>(
    `/api/vendors/claims/${claimId}/documents/${documentId}/download`,
    { method: 'GET' },
  )
}

export async function fetchVendorClaimDetail(claimId: string): Promise<VendorClaimDetailResponse> {
  return $fetch<VendorClaimDetailResponse>(`/api/vendors/claims/${claimId}`)
}

export async function fetchClaimPublicAdjuster(claimId: string): Promise<ClaimPublicAdjusterResponse> {
  return $fetch<ClaimPublicAdjusterResponse>(`/api/claims/${claimId}/public-adjuster`)
}

export async function fetchVendorStatus(): Promise<VendorStatusResponse> {
  return $fetch<VendorStatusResponse>('/api/vendors/status')
}
